<template>
  <div class="pt-card-attribute rev">
    <r-text style="margin-bottom: 8px;" type="caption">
      {{ config.label }}
    </r-text>
    <div class="pt-card-rev-block">
      <r-text>
        {{ feature[config.prop] ? "Обратное" : "Прямое" }}
      </r-text>
    </div>
  </div>
</template>

<script>
export default {
  props: ["feature", "config"]
};
</script>

<style lang="scss">
.pt-card-attribute.rev {
  .pt-card-rev-block {
    width: 100%;
    height: 28px;
    padding: 0 15px;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: var(--border-radius);
    opacity: 0.6;
    border-color: var(--field_border) !important;
    background-color: var(--field_bg) !important;

    .r-text {
      line-height: 26px;
    }
  }
}
</style>
